import { render, staticRenderFns } from "./MoleculeEditionBillingAcademyProductCard2.vue?vue&type=template&id=ba8cc6ec"
import script from "./MoleculeEditionBillingAcademyProductCard2.vue?vue&type=script&lang=js"
export * from "./MoleculeEditionBillingAcademyProductCard2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports